import { Form, Formik } from 'formik';
import React, { useMemo } from 'react';
import { momentInstance } from 'helpers/date-time';
import { cn } from 'helpers/css';
import FormikFields from 'components/FormikFields';
import { Badge } from 'shadcn/components/badge';

const Select24Hours = (props) => {
  const options24hours = useMemo(() => {
    const hours = Array.from({ length: 24 }, (_, i) => {
      const hour = i.toString().padStart(2, '0');
      return {
        label: `${hour}:00`,
        value: `${hour}:00`,
      };
    });
    return hours;
  }, []);

  return (
    <div className={cn('component:Select24Hours', props.className)}>
      <Formik
        enableReinitialize
        initialValues={{
          date: props.date
            ? momentInstance(props.date).set('minute', 0).set('second', 0).format('HH:mm')
            : null,
        }}
        onSubmit={(values) => {
          props.onChange(values.date);
        }}
      >
        {({ handleSubmit }) => {
          return (
            <Form>
              <FormikFields.Select
                options={options24hours}
                name='date'
                afterOnChange={() => {
                  handleSubmit();
                }}
                label={props.label}
                v2={props.v2}
                v2Placeholder={
                  <Badge variant='secondary' className='tw-rounded-sm tw-px-1 tw-font-extrabold'>
                    --:--
                  </Badge>
                }
              />
            </Form>
          );
        }}
      </Formik>
    </div>
  );
};

export default Select24Hours;
